import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["ref"];
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import Button from '../../../../components/Button';
import Icon from '../../../../components/Icon';
import { Dropdown, DropdownItem } from '../../../../components/Dropdown';
import ListButton from '../../../../components/ListButton';
import InfiniteScrollZone from '../../../../components/InfiniteScrollZone';
import ContentLoading from '../../../../components/ContentLoading';
import TeamMemberItem from './TeamMemberItem';
import EmptyState from '../../../../components/EmptyState';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import styles from './MembersView.m.sass';
import List from '../List';
import RequirePerms from '../../../containers/RequirePerms';
import PendingMemberItem from './PendingMemberItem';
var MembersView = function MembersView(_ref) {
  var state = _ref.state;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Filter, {
    state: state
  })), /*#__PURE__*/React.createElement(List, {
    addButton: state.allowEdit ? /*#__PURE__*/React.createElement(RequirePerms, {
      rootStore: state,
      anyOf: ['MANAGE_TEAM_MEMBER'],
      subject: state.sessionStore.teamMembers.find(function (x) {
        return x.teamId === state.team.id;
      })
    }, /*#__PURE__*/React.createElement(ListButton, {
      onClick: state.showInviteModal,
      icon: /*#__PURE__*/React.createElement(Icon, {
        material: true,
        auto: true,
        name: "add"
      })
    }, "Add Team Member")) : state.sessionStore.member.hasPermission('ADMIN_MANAGE_TEAM_MEMBER') && /*#__PURE__*/React.createElement(ListButton, {
      onClick: state.showAddModal,
      icon: /*#__PURE__*/React.createElement(Icon, {
        material: true,
        auto: true,
        name: "add"
      })
    }, "Add Team Member Manually")
  }, state.selectedTeamRoleFilterId === 'Pending invites' ? state.pendingMembers.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
    title: "No results."
  }, "Maybe try", ' ', /*#__PURE__*/React.createElement("a", {
    onClick: state.setRoleFilter.bind(null, null)
  }, "broadening your search?")) : state.pendingMembers.map(function (pendingMember) {
    return /*#__PURE__*/React.createElement(PendingMemberItem, {
      key: pendingMember.id,
      pendingMember: pendingMember
    });
  }) : state.teamMembers.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
    title: "No results."
  }, "Maybe try", ' ', /*#__PURE__*/React.createElement("a", {
    onClick: state.setRoleFilter.bind(null, null)
  }, "broadening your search?")) : state.teamMembers.map(function (teamMember) {
    return /*#__PURE__*/React.createElement(TeamMemberItem, {
      key: teamMember.id,
      teamMember: teamMember,
      state: state
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.filler
  }), /*#__PURE__*/React.createElement(InfiniteScrollZone, {
    scrollProvider: state.memberScroller
  }, function (_ref2) {
    var isDone = _ref2.isDone,
      active = _ref2.active;
    return !isDone && /*#__PURE__*/React.createElement(ContentLoading, {
      smaller: true
    });
  })), /*#__PURE__*/React.createElement(ConfirmDialog, {
    title: "Confirm removal",
    state: state.confirmDeactivateState,
    yes: "Remove Team Member",
    position: "top",
    danger: true
  }, state.removeTeamMember.args && state.removeTeamMember.args[0] && /*#__PURE__*/React.createElement("span", null, "Are you sure you want to remove", ' ', /*#__PURE__*/React.createElement("strong", null, state.removeTeamMember.args[0].member.displayName), "? You can invite them back again later.")));
};
export default observer(MembersView);
var Filter = observer(function Filter(_ref3) {
  var state = _ref3.state;
  var rolesMap = [[null, 'All Members'], ['Pending invites', 'Pending']].concat(_toConsumableArray(state.teamRoles.map(function (r) {
    return [r.id, r.name];
  })));
  var _rolesMap$find = rolesMap.find(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        key = _ref5[0];
      return key === state.selectedTeamRoleFilterId;
    }),
    _rolesMap$find2 = _slicedToArray(_rolesMap$find, 2),
    selectedRoleFilterId = _rolesMap$find2[0],
    selectedRoleFilterLabel = _rolesMap$find2[1];
  return /*#__PURE__*/React.createElement(Dropdown, {
    button: function button(_ref6) {
      var ref = _ref6.ref,
        buttonProps = _objectWithoutProperties(_ref6, _excluded);
      return /*#__PURE__*/React.createElement(Button, _extends({
        outline: true,
        borderless: true,
        iconRight: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          small: true,
          name: "arrow drop down"
        }),
        size: "small",
        innerRef: ref
      }, buttonProps), selectedRoleFilterLabel);
    }
  }, rolesMap.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      label = _ref8[1];
    return /*#__PURE__*/React.createElement(DropdownItem, {
      active: key === selectedRoleFilterId,
      key: key,
      onClick: state.setRoleFilter.bind(state, key)
    }, label);
  }));
});
//# sourceMappingURL=index.js.map
